export const REPORT_OPTIONS = [
  {
    key: "user-signup-overview",
    label: "User & signup overview",
    description: "All accounts, verification status, plan tier, and signup timeline.",
    available: true,
  },
  {
    key: "plan-mix-billing-signal",
    label: "Plan mix & billing signal",
    description: "Subscription mix, upgrades, downgrades, and billing trends.",
    available: true,
  },
  {
    key: "asset-inventory",
    label: "Asset inventory",
    description: "Tracked assets by type, owner, and policy analysis state.",
    available: true,
  },
  {
    key: "analysis-pipeline-health",
    label: "Analysis pipeline health",
    description: "Queue, processing success/failure, and throughput indicators.",
    available: true,
  },
  {
    key: "report-generation-volume",
    label: "Report generation volume",
    description: "Generated reports over time with usage spikes and totals.",
    available: true,
  },
  {
    key: "power-users",
    label: "Power users",
    description: "Top users by report activity, volume, and repeat usage.",
    available: true,
  },
  {
    key: "plan-vs-usage",
    label: "Plan vs usage",
    description: "Compare plan tier limits against real user consumption.",
    available: true,
  },
  {
    key: "stale-or-stuck-work",
    label: "Stale or stuck work",
    description: "Long-pending or incomplete analysis workflows needing action.",
    available: true,
  },
  {
    key: "enterprise-funnel",
    label: "Enterprise funnel",
    description: "Enterprise lead to conversion stages and drop-off points.",
    available: true,
  },
  {
    key: "activity-audit-trail",
    label: "Activity audit trail",
    description: "Chronological platform activity log for review and tracing.",
    available: true,
  },
];
